import { useState } from 'react';
import { X } from 'lucide-react';

const inp = 'w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-green-600 bg-white';

export const ContactCard = ({ onSave, onClose }) => {
  const [f, setF] = useState({ name: '', email: '', phone: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try { await onSave(f); } catch (ex) { setErr(ex.message); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="bg-green-50 border border-green-200 rounded-xl p-3 space-y-2 relative ld-chat-in" data-testid="chat-contact-card">
      <button type="button" onClick={onClose} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Dismiss" data-testid="chat-contact-dismiss"><X size={14} /></button>
      <p className="text-xs font-semibold text-gray-800 pr-5">So we never miss you — where can we reply if you step away?</p>
      <input className={inp} placeholder="Your name" value={f.name} onChange={set('name')} data-testid="chat-contact-name" />
      <input className={inp} type="email" placeholder="Email" value={f.email} onChange={set('email')} data-testid="chat-contact-email" />
      <input className={inp} placeholder="Phone (optional)" value={f.phone} onChange={set('phone')} data-testid="chat-contact-phone" />
      {err && <p className="text-xs text-red-600" data-testid="chat-contact-error">{err}</p>}
      <button disabled={busy} className="w-full bg-green-600 hover:bg-green-700 text-white text-sm font-semibold py-2 rounded-lg transition-colors disabled:opacity-60" data-testid="chat-contact-save">
        {busy ? 'Saving…' : 'Save my details'}
      </button>
    </form>
  );
};
